export default class SubscriptionSituationDto {
    constructor(obj) {
        this.id = obj.idSubscriptionSituation
        this.idSubscription = obj.idSubscription
        this.materielId = obj.idSubscription
        this.siteCode = obj.siteCode
        this.siteType = obj.siteType
        this.siteName = obj.siteName
        this.statusCode = obj.statusCode
        this.comment = obj.comment
        this.situationDate = obj.situationDate
        this.situationEndDate = obj.situationEndDate
        this.campaignCode = obj.campaignCode
        this.campaignCode = obj.campaignCode
        this.administratorCode = obj.administratorCode
        this.updateLogin = obj.updateLogin
        this.updateDate = obj.updateDate
        this.headers = ['siteType', 'siteName', 'statusCode', 'comment', 'situationDate', 'situationEndDate']
    }
}